import React, { useState } from 'react';
import { toast } from 'sonner';
import { FormInput, FormSelect } from '../finance';
import { X, CircleNotch } from '@phosphor-icons/react';
import './transport-forms.css';

function MaintenanceForm({ maintenance, vehicles, onSave, onClose }) {
  const [formData, setFormData] = useState(maintenance || {
    vehicle_id: vehicles.length > 0 ? vehicles[0].id : '',
    maintenance_date: new Date().toISOString().split('T')[0],
    maintenance_type: '',
    description: '',
    cost: 0,
    notes: ''
  });
  const [loading, setLoading] = useState(false);

  const maintenanceTypes = [
    'Oil Change',
    'Tire Replacement',
    'Brake Service',
    'Engine Inspection',
    'Transmission Service',
    'Battery Replacement',
    'Radiator Service',
    'Electrical Repair',
    'Other'
  ];

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'number' ? parseFloat(value) : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.vehicle_id || !formData.maintenance_type || !formData.description || !formData.cost) {
      toast.error('All fields are required');
      return;
    }

    setLoading(true);
    try {
      await onSave(maintenance?.id, formData);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal modal-lg">
        <div className="modal-header">
          <h2>{maintenance ? 'Edit Maintenance' : 'Log Maintenance'}</h2>
          <button onClick={onClose} className="btn-close"><X size={20} /></button>
        </div>

        <form onSubmit={handleSubmit} className="modal-body">
          <div className="form-row">
            <FormSelect
              label="Vehicle"
              name="vehicle_id"
              value={formData.vehicle_id}
              onChange={handleChange}
              required
            >
              {vehicles.map(vehicle => (
                <option key={vehicle.id} value={vehicle.id}>
                  {vehicle.registration_number} - {vehicle.make} {vehicle.model}
                </option>
              ))}
            </FormSelect>

            <FormInput
              label="Maintenance Date"
              name="maintenance_date"
              type="date"
              value={formData.maintenance_date}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-row">
            <FormSelect
              label="Maintenance Type"
              name="maintenance_type"
              value={formData.maintenance_type}
              onChange={handleChange}
              required
            >
              <option value="">-- Select Type --</option>
              {maintenanceTypes.map(type => (
                <option key={type} value={type}>{type}</option>
              ))}
            </FormSelect>

            <FormInput
              label="Cost (GHS)"
              name="cost"
              type="number"
              value={formData.cost}
              onChange={handleChange}
              required
              step="0.01"
              min="0"
            />
          </div>

          <FormInput
            label="Description"
            name="description"
            as="textarea"
            value={formData.description}
            onChange={handleChange}
            required
            rows="3"
            placeholder="Describe the maintenance work performed"
          />

          <FormInput
            label="Notes"
            name="notes"
            as="textarea"
            value={formData.notes}
            onChange={handleChange}
            rows="2"
          />

          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose} disabled={loading}>
              Cancel
            </button>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? (
                <span className="button-loading">
                  <CircleNotch size={16} weight="fill" className="spinner" />
                  Saving...
                </span>
              ) : 'Log Maintenance'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default MaintenanceForm;
